"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokensResolvingContext = void 0;
var local_storage_tokens_resolving_strategy_1 = require("./local-storage-tokens-resolving-strategy");
var strategy = local_storage_tokens_resolving_strategy_1.localStorageTokensResolvingStrategy;
var setStrategy = function (newStrategy) {
    strategy = newStrategy;
};
var getTokens = function () {
    return strategy.execute();
};
exports.tokensResolvingContext = {
    getTokens: getTokens,
    setStrategy: setStrategy,
};
